import {blue600, white, grey600} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    header: {
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue600,
        color: white
    },
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    label: {
        color: grey600,
        lineHeight: '1em',
        marginBottom: '5px'
    },
    text: {
        lineHeight: '1em',
        marginTop: '5px',
        marginBottom: '5px'
    },
    button: {
        marginTop: 20
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/application/ApplicationList/ApplicationList.css.js